import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FIELD_TYPES } from "../../../../../../libs/formdatavalidator/constants";
import FormEventHandlers from "../../../../../../libs/utility/formeventhandlers/FormEventHandlers";
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import FormInput from "../../../../../components/forminput/FormInput";
import { TOASTER_VARIANT } from "../../../../../components/toast/constants";
import Intermediary from "../../../../components/intermediary/Intermediary";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { FORM_STEP } from "../../constants";
import { onDependentFieldChangeGetValues } from "../../CreateFormSaga";
import { setHelpTextObj, setReloadFormsPreLoadedData, setShowHelpPopup, setTempFormFieldsList } from "../../CreateFormSlice";
import styles from './RenderFields.styles';
import Forms from "../../../../../../libs/utility/formsutility/Forms";

export default function RenderFields({ step, tempFormFieldsList, formsPreLoadedData, toCreateFormData, onDependentFields }) {

	const [isOpenIntermediaryPopup, setIsOpenIntermediaryPopup] = useState(false);
	const [intermediaryIdForEdit, setIntermediaryIdForEdit] = useState(null);

	const dispatch = useDispatch();

	const handleDispatchNotification = (heading, message, variant = "DANGER") => {
        dispatch(addNotifications({
            heading: heading,
            message: message,
            variant: TOASTER_VARIANT[variant]
        }))
    }

	const renderHTML = (step, tempFormFieldsList, formsPreLoadedData, toCreateFormData, onDependentFields) => {
		const groupedFields = [];

		tempFormFieldsList.forEach((formField) => {
			if (formField?.Category === step && formField?.isVisible !== false && (formField?.Category !== FORM_STEP.FEDERAL || formField?.isSelected)) {
				
				if (formField.GroupId) {
					Forms.groupFormFields(groupedFields, formField)
				} else {
					groupedFields.push([formField]);
				}
			}
		});
		
		return (
			<>
				{groupedFields.map((group, index) => (
					<>
						{(index !== 0 && groupedFields[index][0]?.StepViewSort?.Column !== groupedFields[index-1][0]?.StepViewSort?.Column) ?
							<div style={styles.grayBorder}></div>
						: ""}
						<div key={index} style={{...styles.parentFieldDiv ,...(group.length > 1) ? styles.groupContainer : {}}}>
							{
								('GroupLabel' in group[0] && group[0]?.GroupLabel) && <span style={styles.groupFieldsLabel}>
								{ group[0]?.BoxInfo?.Box ? `${group[0].BoxInfo.Box}. ${group[0]?.GroupLabel}` : group[0]?.GroupLabel }
							</span>
							}
							
							{group.map((formField, idx) => (
								<React.Fragment key={idx}>
									<div id={`container_${formField.Name}`} style={{...styles.boxInputFieldContainer, ...((formField?.StepViewSort?.Column === (group[idx-1]?.StepViewSort?.Column ?? group[idx]?.StepViewSort?.Column)) ? styles.groupFieldFullWidth : {})}}>
										{formField.Type !== FIELD_TYPES.BOOLEAN && (
											<span style={styles.boxInputFieldLabel}>
												{('GroupLabel' in formField && formField?.GroupLabel) ? formField.Label : (formField?.BoxInfo?.Box) ? `${formField.BoxInfo.Box}. ${formField.Label}` : formField.Label}
												{formField?.Validations?.Required?.Value ? <span style={styles.requiredStarLabel}>
                                                <span title={`${formField.Name} is Required`}>*</span>
                                            </span> : null}
											</span>
										)}
										<FormInput
											name={formField.Name}
											type={formField.Type}
											placeHolder={formField.PlaceholderText}
											onChangeCb={(e) => FormEventHandlers.inputValueChange(e, formField, tempFormFieldsList, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), toCreateFormData, onDependentFields, (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), false)} 
											fieldObj={formField}
											fieldsArr={tempFormFieldsList}
											prefixProps={(formField.Type === FIELD_TYPES.CURRENCY) ? { text: "$" } : {}}
											onBlurCb={(e, inputValidationResult) => FormEventHandlers.handleOnBlur(e, formField, tempFormFieldsList, inputValidationResult, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)))}
											hideBorder={(formField.Type === FIELD_TYPES.BOOLEAN) ? true : false}
											options={(formsPreLoadedData[formField?.FrontEndSource] && Array.isArray(formsPreLoadedData[formField.FrontEndSource]) ? formsPreLoadedData[formField.FrontEndSource] : [])}
											dropdownValue={
												(formField?.inputValue && formField.inputValue != "")
													? 
														(formsPreLoadedData[formField?.FrontEndSource] && Array.isArray(formsPreLoadedData[formField.FrontEndSource]) ? formsPreLoadedData[formField.FrontEndSource] : []).find(item => item.value == formField.inputValue) 
													: 
														{label: "select", value: ""}
											}
											dropdownOnSelectCb={(name, selectedOption) => FormEventHandlers.handleDropDownValueChange(name, selectedOption, tempFormFieldsList, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), () => {}, true, (heading, message, variant) => handleDispatchNotification(heading, message, variant), false)}
											customStyles={(formField.Type === FIELD_TYPES.BOOLEAN) ? styles.boxInputFieldLabel : ""}
											formsPreLoadedData={formsPreLoadedData}
											disabled={formField?.isReadonly ? true : false} 
											dispatchNotificationCb={(heading, message, variant) => addNotifications({
												heading: heading,
												message: message,
												variant: TOASTER_VARIANT[variant]
											})}
											tabIndex="0"
											helpIconProps={{
												onClickCb: (helpText) => {
													dispatch(setShowHelpPopup(true));
													dispatch(setHelpTextObj(helpText));
												}
											}} 
										/>
										{   
											formField.Name === "IntermediaryId" ? 
												<div style={styles.addEditIntermediaryButtonsDiv}>
													<Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => FormEventHandlers.handleAddEditIntermediaryAction(setIntermediaryIdForEdit, setIsOpenIntermediaryPopup)} >Add Intermediary</Button>
													<Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => formField?.inputValue ? FormEventHandlers.handleAddEditIntermediaryAction(setIntermediaryIdForEdit, setIsOpenIntermediaryPopup, formField?.inputValue) : dispatch(addNotifications({ heading: "Intermediary is not selected", message: "Please select an intermediary" }))} >Edit</Button>
													{
														isOpenIntermediaryPopup && <Intermediary intermediaryIdForEdit={intermediaryIdForEdit} isPopup={true} isPopupOpen={isOpenIntermediaryPopup} onPopupCloseCb={() => setIsOpenIntermediaryPopup(false)} onSubmitCb={() => dispatch(setReloadFormsPreLoadedData(true))} />
													}
												</div>
											: null
										}
									</div>
								</React.Fragment>
							))}
						</div>
					</>
				))}
			</>
		);
	};

	return <>
		{renderHTML(step, tempFormFieldsList, formsPreLoadedData, toCreateFormData, onDependentFields)}
	</>
}